import React from 'react';
import classNames from 'classnames';
import testimonialAvatar from './testimonial-avatar.jpg';

import { Link } from '@mm/components';
import { LoginType } from '@mm/state/controllers/SessionController';

import { SignUpLogo } from '../../../../../dashboard/pages/SignUp/SignUp/SignUpLogo/SignUpLogo';

import { Badges } from '../components/Badges/Badges';

import css from './SmbLayout.module.css';
import { useAuthBtn } from '../use-auth-btn';

type Props = {
  className?: string;
  children?: any;
};

export const SmbLayout = ({ className, children }: Props) => {
  const { authBtnText, authLinkDestination, isSignUp } = useAuthBtn(
    LoginType.smb,
  );

  return (
    <div className={classNames(className, css.wrapper)}>
      <div className={css.background}>
        <div className={css.left} />
        <div className={css.right} />
      </div>

      <div className={css.container}>
        <div className={css.navbar}>
          <SignUpLogo className={css.logo} />
          <Link className={css.login} to={authLinkDestination}>
            {authBtnText}
          </Link>
        </div>

        <div className={css.content}>
          <div className={css.section}>
            <div className={css.description}>
              <span className={css.headline}>
                Never miss a lead and be available to customers 24/7 — without
                losing sleep
              </span>

              <span className={css.subtitle}>
                SMBots is the next-generation live chat platform for B2C
                business owners
              </span>

              <div className={css.testimonial}>
                <div className={css.avatar}>
                  <img src={testimonialAvatar} alt="Cat Howell" />
                </div>
                <div className={css.info}>
                  <span className={css.name}>Angel Buendía</span>
                  <span className={css.position}>Movimientos Sagrados</span>
                  <span className={css.mark}>“</span>
                  <p className={css.quote}>
                    Customers.ai automations have been the best solution we
                    could imagine. It makes our life much easier because it’s
                    solved our greatest problem, which is making real contact
                    with people who are looking for our services.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={css.section}>
            <div className={css.card}>
              <Badges
                className={classNames(css.badges, {
                  [css.centeredBadges]: !isSignUp,
                })}
                isSignUp={isSignUp}
              />
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
